import { render, staticRenderFns } from "./DishRelationPage.vue?vue&type=template&id=46e79f7a&scoped=true&"
import script from "./DishRelationPage.vue?vue&type=script&lang=js&"
export * from "./DishRelationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e79f7a",
  null
  
)

export default component.exports